import { Box, Col } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { Text } from '@opendoor/atoms/text';
import type { EntryComponent } from 'cms/entries/entries';
import type { IComparePhotoTestimonials } from 'declarations/contentful';

import { resizeTestimonialCardImageUrl } from './shared/utils';

const RenderComparePhotoTestimonials = (entry: IComparePhotoTestimonials) => {
  const { fields } = entry;

  return (
    <Box className="bg-od-bg-primary py-20 max-md:py-12">
      <Box className="mx-auto block w-full max-w-280 px-6">
        <Col className="gap-6">
          <Col className="gap-3">
            <Text as="p" className="text-label-sm text-od-content-accent-brand">
              {fields.eyebrow}
            </Text>
            <Text
              as="h2"
              className="text-subheader-lg text-od-content-primary max-md:text-subheader-md"
            >
              {fields.title}
            </Text>
            <Text as="p" className="max-w-145 text-body-lg leading-[1.6] text-od-content-secondary">
              {fields.description}
            </Text>
          </Col>

          <Col className="gap-6 md:flex-row">
            {fields.cards.map((card) => (
              <Col
                key={card.sys.id}
                className="flex-1 overflow-hidden rounded-2xl bg-od-bg-secondary"
              >
                <Image
                  src={resizeTestimonialCardImageUrl(card.fields.imageUrl)}
                  alt={card.fields.imageAlt || card.fields.name}
                  className="h-55 w-full object-cover"
                />
                <Col className="gap-5 p-6">
                  <Text as="p" className="text-body-sm leading-[1.7] text-od-content-primary">
                    &ldquo;{card.fields.quote}&rdquo;
                  </Text>
                  <Col className="gap-0.5">
                    <Text as="span" className="text-label-sm text-od-content-primary">
                      {card.fields.name}
                    </Text>
                    <Text as="span" className="text-xs text-od-content-tertiary">
                      {card.fields.location}
                    </Text>
                  </Col>
                </Col>
              </Col>
            ))}
          </Col>
        </Col>
      </Box>
    </Box>
  );
};

const ComparePhotoTestimonials: EntryComponent<IComparePhotoTestimonials> = {
  render: RenderComparePhotoTestimonials,
};

export default ComparePhotoTestimonials;
